/**
 * Generated bundle index. Do not edit.
 */

export {NgFormControlErrorsModule,Error,Errors,NgFormControlErrorsComponent} from './public_api';

export {NgFormControlErrorsContent as ɵa} from './src/app/ng-form-control-errors/ng-form-control-errors-content';
export {NgFormControlErrorsInvalid as ɵb} from './src/app/ng-form-control-errors/ng-form-control-errors-invalid';